const GATED_MARKER = "data-consent-gated"

interface ScriptOptions {
  type?: string
  attributes?: Record<string, string | undefined>
}

function injectScript(src: string, options: ScriptOptions = {}): void {
  const script = document.createElement("script")
  script.src = src
  script.setAttribute(GATED_MARKER, "true")
  if (options.type) script.type = options.type
  if (options.attributes) {
    Object.entries(options.attributes).forEach(([key, value]) => {
      if (value != null) script.setAttribute(key, value)
    })
  }
  document.head.appendChild(script)
}

function triggerSegment(): void {
  const analytics = window.analytics as
    | (SegmentAnalytics.AnalyticsJS & { _writeKey?: string })
    | undefined
  if (analytics && typeof analytics.load === "function" && analytics._writeKey) {
    analytics.load(analytics._writeKey)
    // Capture the current page as soon as Segment loads. This is belt-and-
    // suspenders: the plugin's onRouteUpdate also fires on initial load and,
    // under trackPageOnlyIfReady: false, buffers a page() into the pre-load
    // stub that replays on load(). Both routes share the plugin's
    // lastPageviewPath dedup, so whichever runs second no-ops — exactly one
    // pageview fires post-consent. Kept to cover the race where consent
    // resolves before that route-update timer; safe to drop if the deploy-
    // preview network audit confirms the route-update path alone captures it.
    window.gatsbyPluginSegmentPageviewCaller?.()
  }
}

export function loadGatedScripts(): void {
  if (document.querySelector(`script[${GATED_MARKER}]`)) return

  injectScript("/scripts/onelink-smart-script.js")
  injectScript("/scripts/hot-jar-tracking.js")
  injectScript("/scripts/snap-pixel.js", { type: "text/javascript" })
  injectScript("/scripts/analytics-middleware.js", {
    attributes: { branch: process.env.BRANCH },
  })
  triggerSegment()
}
